var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as yup from 'yup';
import { FIRST_NAME_INVALID, LAST_NAME_INVALID, FIRST_NAME_REQUIRED, LAST_NAME_REQUIRED, ZIPCODE_REQUIRED, LAST_NAME_TOO_LONG, FIRST_NAME_TOO_LONG, } from '../../constants/field-error-messages';
import { NAME_REGEX, ZIPCODE_REGEX } from '../../constants/regex';
var commonValidationSchema = {
    firstName: yup
        .string()
        .trim()
        .required(FIRST_NAME_REQUIRED.message)
        .max(40, FIRST_NAME_TOO_LONG.message)
        .matches(NAME_REGEX, FIRST_NAME_INVALID.message),
    lastName: yup
        .string()
        .trim()
        .required(LAST_NAME_REQUIRED.message)
        .max(60, LAST_NAME_TOO_LONG.message)
        .matches(NAME_REGEX, LAST_NAME_INVALID.message),
};
export var b2bValidationSchema = yup
    .object(__assign({}, commonValidationSchema))
    .required();
export var b2cValidationSchema = yup
    .object(__assign(__assign({}, commonValidationSchema), { zipCode: yup
        .string()
        .required(ZIPCODE_REQUIRED.message)
        .matches(ZIPCODE_REGEX, ZIPCODE_REQUIRED.message) }))
    .required();
